var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"pdf-preview-container"},_vm._l((_vm.docPages),function(page){return _c('div',{key:page,ref:"container",refInFor:true,staticClass:"page-container",style:({
      height: `${_vm.pageHeight}px`
    })},[(_vm.renderList.includes(page))?_c('canvas'):_vm._e()])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }